/* tslint:disable no-string-literal */
import { Component, OnInit, Input, Output, EventEmitter, Renderer2, Inject, ViewChild, OnChanges, ViewChildren, QueryList } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToolTransferService } from 'src/app/component/tools/tool-transfer/tool-transfer.service';
import { ToolInventoryTransferService } from 'src/app/component/tools/tool-inventory-transfer/tool-inventory-transfer.service';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import { DOCUMENT } from '@angular/common';
import {
  AutoCompleteFetchModel,
  AutoCompleteSelectModel,
} from 'src/app/component/shared/autocomplete/autocomplete.model';
import { ToolsService } from 'src/app/service/tools/tools.service';
import { JobParams } from '../../../tools/tool-transfer/tool-transfer.model';
import { PermissionsService } from 'src/app/service/auth/permissions.service';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { MomentService } from 'src/app/service/shared/moment/moment.service';
import getAndParseUserPermissions from 'src/app/helpers/parsePermissions';
import { ToolInventoryModalService } from 'src/app/component/tools/tool-inventory-modal/tool-inventory-modal.service';


type SearchFilterParams = {
  search: string
  searchFilters: Record<string, string | unknown>
}

@Component({
  selector: 'app-tool-settings-bar',
  templateUrl: './tool-settings-bar.component.html',
  styleUrls: ['./tool-settings-bar.component.scss'],
})
export class ToolSettingsBarComponent implements OnInit, OnChanges {
  @ViewChild('jobsAutocomplete') jobsAutocomplete;
  @ViewChild('assetClassDropDownFilter') assetClassDropDownFilter;
  @ViewChild('employeesFilter') employeesFilter;
  @ViewChild('categoriesFilter') categoriesFilter;
  @ViewChild('assignmentTypesDropDownFilter') assignmentTypesDropDownFilter;
  @ViewChild('shopOriginationDropDownFilter') shopOriginationDropDownFilter;
  @ViewChild('manufacturersFilter') manufacturersFilter;
  @ViewChild('statusFilter') statusFilter;
  @ViewChild('ownerFilter') ownerFilter;
  @ViewChild('shopFilter') shopFilter;
  @ViewChild('batchNumberFilter') batchNumberFilter;
  @ViewChild('assignedToFilter') assignedToFilter;
  @ViewChild('assignedFromFilter') assignedByFilter;
  @ViewChild('assignedByFilter') assignedFromFilter;
  @ViewChild('toolsFilter') toolsFilter;
  @ViewChild('assignedDateRange') assignedDateRange;
  @ViewChild('departmentsFilter') departmentsFilter;

  @ViewChildren('inventoryFilter') inventoryFilters: QueryList<any>;
  jobParams = JobParams;

  @Input() searchBarSide = 'right';
  @Input() editAccess = true;
  @Input() toolSettingsData: any;
  @Input() filters: Array<any> = [];
  @Input() moreFilters: Array<any> = [];
  @Input() source: string;
  @Input() defaultOrder = {}

  @Output() search = new EventEmitter<string>();
  @Output() create = new EventEmitter<string>();
  @Output() filter = new EventEmitter<any>();
  @Output() clearSearchFilterParams = new EventEmitter<SearchFilterParams>()
  @Output() transfer = new EventEmitter<any>();
  @Output() inventory = new EventEmitter<any>();
  @Output() inventoryTransfer = new EventEmitter<any>();
  @Output() exportSettings = new EventEmitter<any>();
  @Output() exportTools = new EventEmitter<any>();
  @Output() exportToolModels = new EventEmitter<any>();
  @Output() exportTransfers = new EventEmitter<any>();
  @Output() exportInventories = new EventEmitter<any>();
  @Output() clearFilters = new EventEmitter<void>();

  filterType: string;
  searchFilters: any = {};
  transferCount = 0;
  inventoryCount = 0;
  searchInput = '';
  fleetVehicleInput = '';
  private toolSubscription: Subscription;
  private inventoryModalSubscription: Subscription;
  private inventoryTransferSubscription: Subscription;
  list;
  userPermissions;
  exportType: string;
  selectedDateRange: any = '';
  assignmentFilterProps = {};
  rentalRatesIncluded: boolean = false;
  isVehicleModel: boolean = false;
  stickyFilterProperties = ['scope[assignment_types]'];

  constructor(
    private toolTransferService: ToolTransferService,
    private toolInventoryModalService: ToolInventoryModalService,
    private toolInventoryTransferService: ToolInventoryTransferService,
    private toolsService: ToolsService,
    private localStorageService: LocalstorageService,
    /* tslint:disable-next-line variable-name */
    @Inject(DOCUMENT) public _document,
    public renderer2: Renderer2,
    public permissionsService: PermissionsService,
    private loaderService: LoaderService,
    private toastService: ToastService,
    private momentService: MomentService,
  ) { }

  ngOnInit(): void {
    this.isVehicleModel = Boolean(this.searchFilters['scope[isVehicleModel]']);
    this.toolTransferService.loadFromLocalStorage();
    this.toolInventoryTransferService.loadFromLocalStorage();
    this.toolSubscription = this.toolTransferService.selectedItems.subscribe
      (data => (this.transferCount = data.length));
    this.inventoryModalSubscription = this.toolInventoryModalService.selectedInventoryItems.subscribe(data => this.inventoryCount = data.length)
    this.inventoryTransferSubscription = this.toolInventoryTransferService.selectedInventoryItems.subscribe
      (data => (this.inventoryCount = data.length));


    this.loadOptionsData();

    if (this.moreFilters) this.loadMoreOptionsData();
    this.loadSelect2();
    setTimeout(() => this.loadSelect2MultipleWithCheck(), 700);

    this.userPermissions = getAndParseUserPermissions(this.localStorageService)
  }

  ngOnDestroy() {
    if (this.toolSubscription) this.toolSubscription.unsubscribe();
    if (this.inventoryTransferSubscription) this.inventoryTransferSubscription.unsubscribe();
    if (this.inventoryModalSubscription) this.inventoryModalSubscription.unsubscribe()
  }


  applyActiveByDefaultFilters() {
    const hasMoreFilters = !!this.moreFilters;

    if (!hasMoreFilters) {
      this.filter.emit(this.searchFilters);
      return;
    }

    const possibleAdditionalFilters =
      this.moreFilters
        .filter(el => el?.options?.filter(op => op?.selectedByDefault)?.length)
        ?.map(el => ({
          propertyName: el.propertyName,
          options: el?.options?.filter(op => op?.selectedByDefault).map(op => op.name),
        })) ?? [];

    const noFiltersToApply = !possibleAdditionalFilters?.length;

    if (noFiltersToApply) return;

    possibleAdditionalFilters.forEach(el => {
      const options = el.options.reverse().toString();
      this.searchFilters[el.propertyName] = options;
    });

    this.filter.emit(this.searchFilters);
  }

  capitalize(word: string) {
    return word[0].toUpperCase() + word.slice(1).toLowerCase();
  }

  isAllowed(resource: string, action: string) {
    const resources = {
      tools: 'tools',
      models: 'tool_models',
      manufacturers: 'tools_setting',
      categories: 'tools_setting',
      'shop-locations': 'tools_setting',
      'asset-classes': 'tools_setting',
    };
    const resource1 = resources[resource];
    return this.permissionsService.allow({ resource1, action });
  }

  loadSelect2MultipleWithCheck(className = '.select2MultipleWithCheck') {
    const s1 = this.renderer2.createElement('script');
    s1.type = 'text/javascript';
    s1.text = `loadSelect2MultipleWithCheck('` + className + `','Status');`;
    this.renderer2.appendChild(this._document.body, s1);
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  ngOnChanges() {
    this.filterType =
      this.source === 'tools' ? 'toolFilter' : this.source === 'models' ? 'modelFilter' : this.source === 'transfer' ? 'transferFilter' : 'inventoryFilter';

    if (this.filterType) {
      const filterData = this.localStorageService.getItem(this.filterType);
      if (filterData) {
        this.searchFilters = JSON.parse(filterData);
      }
    }
    if (this.source === 'models' && this.searchFilters) {
      this.searchFilters['scope[enabled]'] = true;
    }

    if (this.source === 'inventories' && this.searchFilters) {
      this.searchFilters['scope[inventory]'] = 1;
    }

    if (this.source === 'transfer' && this.searchFilters) {
      return;
    }

    // Trigger "activeByDefault" filters
    this.applyActiveByDefaultFilters();
  }

  async loadOptionsData() {
    const promiseList = this.filters.map(async filter => {
      if (typeof filter.loadOptions === 'function') {
        const options = await filter.loadOptions();

        filter.options = options;
      }
    });
    await Promise.all(promiseList);
  }

  handleSave(e) { }

  async loadMoreOptionsData() {
    const promiseList = this.moreFilters.map(async filter => {
      if (typeof filter.loadOptions === 'function') {
        const options = await filter.loadOptions();

        filter.options = options;
      }
    });
    await Promise.all(promiseList);
  }

  checkIsSelected(id: string, type: string): boolean {
    const searchData = this.searchFilters[type];

    return searchData && searchData.includes(id);
  }

  includeRentalRatesChecked(event) {
    const hasRentalRates = event.target.checked ? true : '';

    this.searchFilters['scope[hasRentalRates]'] = hasRentalRates;

    this.filter.emit(this.searchFilters);
  }

  vehicleModelsChecked(event) {
    const isChecked: boolean = event.target.checked;
    const vehicleModelValue = isChecked || '';

    this.searchFilters['scope[isVehicleModel]'] = vehicleModelValue;
    this.isVehicleModel = isChecked;
    this.filter.emit(this.searchFilters);
  }

  clearFilter() {
    this.localStorageService.removeItem(this.filterType);
    this.localStorageService.removeItem('selected-jobs');

    Object.keys(this.searchFilters).forEach(key => {
      if (!this.stickyFilterProperties.includes(key)) {
        this.searchFilters[key] = '';
      } else {
        this.saveStickyFilters(key);
      }
    });

    this.filters.map(async filter => {
      filter.default = '';
    });

    // reset filter defaults
    this.filters.forEach(filter => (filter.default = ''));
    if (this.moreFilters) {
      this.moreFilters.forEach(filter => (filter.default = ''));
    }

    if (this.moreFilters) {
      this.moreFilters.map(async filter => {
        filter.default = '';
      });
    }
    if (this.filterType === 'toolFilter') {
      this.jobsAutocomplete.clearFilter();
      this.employeesFilter.clearFilter();
      this.categoriesFilter.clearFilter();
      this.departmentsFilter.clearFilter();
      this.ownerFilter.clearFilter();
      this.shopFilter.clearFilter();
      this.assetClassDropDownFilter.clearFilter();
      this.assignmentTypesDropDownFilter.clearFilter();
      this.shopOriginationDropDownFilter.clearFilter();
      this.ownerFilter.clearFilter();
      this.shopFilter.clearFilter();
      this.isVehicleModel = false;
    } else if (this.filterType === 'modelFilter') {
      this.assetClassDropDownFilter.clearFilter();
      this.categoriesFilter.clearFilter();
      this.statusFilter.clearFilter();
      this.manufacturersFilter.clearFilter();
    } else if (this.filterType === 'transferFilter') {
      this.batchNumberFilter.clearFilter();
      this.assignedToFilter.clearFilter();
      this.assignedFromFilter.clearFilter();
      this.assignedByFilter.clearFilter();
      this.toolsFilter.clearFilter();
      this.categoriesFilter.clearFilter();
      this.departmentsFilter.clearFilter();
      this.clearDaterangeFilter('scope[assignedDateRange]');
      this.selectedDateRange = '';
      this.rentalRatesIncluded = false;
    } else if (this.filterType === 'inventoryFilter') {
      this.inventoryFilters.forEach(f => f.clearFilter());
      this.clearDaterangeFilter('scope[assignedDateRange]');
    } else {
      this.batchNumberFilter.clearFilter();
      this.assignedToFilter.clearFilter();
      this.toolsFilter.clearFilter();
      this.categoriesFilter.clearFilter();
      this.departmentsFilter.clearFilter();
    }
    this.selectedDateRange = '';
    this.searchInput = '';
    this.fleetVehicleInput = '';

    const emitParams = {
      search: '',
      searchFilters: { ...this.searchFilters }
    }

    if (this.defaultOrder) emitParams.searchFilters.order = this.defaultOrder
    else {
      delete emitParams.searchFilters.order
    }

    this.clearSearchFilterParams.emit(emitParams)

    this.toastService.showToast('Filters cleared successfully', 'success');
  }

  saveStickyFilters(property: string) {
    if (!this.stickyFilterProperties.includes(property)) return;

    const filters = JSON.parse(this.localStorageService.getItem(this.filterType));
    const value = JSON.stringify({
      ...filters,
      [property]: this.searchFilters[property],
    });

    this.localStorageService.setItem(this.filterType, value);
  }

  toolIdSearch(event: KeyboardEvent) {
    const { value } = event.target as HTMLInputElement;
    this.toolsService.read['tools']({ search: value }).subscribe(res => {
      this.filters.filter(f => f.model === 'tools')[0].options = res.data;
    });
  }

  triggerChange(obj) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `triggerChangeWithValue('` + obj + `');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  clearSelect2MultipleWithCheck(className = '.select2MultipleWithCheck') {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `clearSelect2MultipleWithCheck('` + className + `');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  setSelect2MultipleWithCheck(className = '.select2MultipleWithCheck', searchInfo = {}) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `setSelect2MultipleWithCheck('` + className + `', [` + searchInfo['status'] + `]);`;
    this.renderer2.appendChild(this._document.body, s);
    const s1 = this.renderer2.createElement('script');
    s1.type = 'text/javascript';
    s1.text = `setSelect2MultipleWithCheck('` + className + `', [` + searchInfo['assetClasses'] + `]);`;
    this.renderer2.appendChild(this._document.body, s1);
  }

  submitSearch(): void {
    this.search.emit(this.searchInput);
  }

  submitFleetSearch(): void {
    this.searchFilters['scope[fleetVehicleNumber]'] = this.fleetVehicleInput;
    this.filter.emit(this.searchFilters);
  }

  submitCreate(): void {
    this.create.emit(this.toolSettingsData.type);
  }

  // by default, the option.id property will be used as the value
  // for options in a <select> tag. If a custom property is assigned
  // to the filter.value, this method determines which property
  // should be used for the value of the option
  getOptionValue(filter: any, option: any): any {
    return filter.value ? option[filter.value] : option.id;
  }

  submitFilters(property: string, event: any): void {
    const hasValue = event.target.value && event.target.value !== 'null';
    const value = hasValue ? event.target.value : '';

    this.searchFilters[property] = value;
    this.filter.emit(this.searchFilters);
  }

  submitMultipleFilter(property: string, event: any): void {
    this.submitFilters(property, event);
  }

  submitDaterangeFilter(property, data): void {
    if (!data.start && !data.end) return;
    this.searchFilters[property] = `${this.momentService.getDBDateFormat(
      data.start.toString(),
    )},${this.momentService.getDBDateFormat(data.end.toString())}`;
    this.filter.emit(this.searchFilters);
  }

  clearDaterangeFilter(property) {
    if (!this.searchFilters[property]) return;
    this.selectedDateRange = '';

    this.searchFilters[property] = '';
    this.filter.emit(this.searchFilters);
  }

  submitSingleFilter(property, data): void {
    if (typeof data === 'object' && data !== null) data = !Object.keys(data).length ? null : data;
    if (data) {
      //multi-dimensional filter props (Assignments)
      if (data?.value && data?.propertyType) {
        this.assignmentFilterProps[property] = data.propertyType;
        this.searchFilters[`${property}[${data.propertyType}]`] = data.value;
        this.filter.emit(this.searchFilters);
      } else {
        //single-dimensional filter props (Assignments)
        if (data?.value) {
          this.searchFilters[property] = data.value;
          this.filter.emit(this.searchFilters);
        } else {
          //Normal filters
          this.searchFilters[property] = data;
          this.filter.emit(this.searchFilters);
        }
      }
    } else {
      //filter data empty
      if (this.assignmentFilterProps?.[property]) {
        //clearing multi-dimensional filter props
        let propertyType = this.assignmentFilterProps[property];
        this.searchFilters[`${property}[${propertyType}]`] = typeof data === 'boolean' ? 'false' : '';
      } else {
        //clearing normal filter props
        this.searchFilters[property] = typeof data === 'boolean' ? 'false' : '';
      }
      this.filter.emit(this.searchFilters);
    }
  }

  submitAutocompleteMultipleFilter(property: string, data): void {
    const hasValue = Array.isArray(data) && data.length > 0;
    const value = hasValue ? data.toString() : '';

    this.searchFilters[property] = value;
    this.filter.emit(this.searchFilters);

    //Set sticky default filters to local storage
    this.saveStickyFilters(property);
  }

  get autoCompleteMap() {
    return {
      jobs: this.jobsAutocomplete,
    };
  }

  get paramsMap() {
    return {
      jobs: this.jobParams,
    };
  }

  fetch(model: AutoCompleteFetchModel) {
    const { namespace, search } = model;
    const autocomplete = this.autoCompleteMap[namespace];
    let params = this.paramsMap[namespace];
    params = { ...params, search };
    this.toolsService.list[namespace](params).subscribe(res => {
      autocomplete.fetchSuccessHandler(res);
    });
  }

  fetchNext(model: AutoCompleteFetchModel) {
    const { namespace, page } = model;
    const autocomplete = this.autoCompleteMap[namespace];
    let params = this.paramsMap[namespace];
    params = { ...params, page };
    this.toolsService.list[namespace](params).subscribe(res => {
      autocomplete.fetchNextSuccessHandler(res);
    });
  }

  submitAutoCompleteFilter(model: AutoCompleteSelectModel) {
    const { item, id } = model;
    this.searchFilters[id] = item.id;
    this.filter.emit(this.searchFilters);
  }

  saveFilter() {
    this.localStorageService.setItem(this.filterType, JSON.stringify(this.searchFilters));
    this.filter.emit(this.searchFilters);
    this.toastService.showToast('Filters saved successfully ', 'success');
  }

  emitTransfer() {
    this.transfer.emit();
  }

  emitInventory() {
    this.inventory.emit();
  }

  emitInventoryTransfer() {
    this.inventoryTransfer.emit();
  }

  setToolExportType(type: string) {
    this.exportType = type;
  }

  emitExport(exportType: string) {
    this.loaderService.displayLoader();
    if (['asset-classes', 'manufacturers', 'categories', 'shop-locations'].includes(exportType))
      this.exportSettings.emit({ settingsExportType: exportType });
    if (exportType === 'tools') this.exportTools.emit({ toolExportType: this.exportType });
    if (exportType === 'models') this.exportToolModels.emit({ modelExportType: this.exportType });
    if (exportType === 'transfers') this.exportTransfers.emit({ transferExportType: this.exportType });
    if (exportType === 'inventories') this.exportInventories.emit({ inventoryExportType: this.exportType });
  }

  checkIsExportButtonDisabled() {
    const isOnInventoryPage = this.toolSettingsData.type === 'inventories'

    if (isOnInventoryPage) {
      return !this.userPermissions.tool_inventory.edit
    }

    return false
  }
}
